module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00006-fs8.b070c95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00006-fs8.png
// module id = 160
// module chunks = 0